import { Container, ContainerGutter, ContainerPadding, CTA, styled, Text, TokenTextAppearance, TokenTextColor, TextTag } from '@volkswagen-onehub/components-core';
import React from 'react';
import LocalDealer from '../components/LocalDealer';
import ResultsHeadline from '../components/ResultsHeadline';
import { getTranslations } from '../translations';
import { useFeatureServices } from '../use-feature-services';
import { createConstantData, createPartner } from '../utils/get-tracking-event-data';
import { replaceStringWithJSX } from '../utils/replace-string-with-jsx';
import FactoryOrder from '../components/FactoryOrder';
import { useDealersStore } from '../utils/use-dealers-store';
import { useAppliedFilterStore } from '../store/filtersv2';

const DealerizationContainer = styled.div`
    margin-bottom: var(--size-dynamic0100);
    padding: ${({ theme }) => theme.size.dynamic0050};
    border: 1px solid rgb(223, 228, 232);
    border-radius: 8px;
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-row-gap: var(--size-dynamic0100);
`;

const LocalDealerHeadline = styled.div`
    grid-row: 1 / 2;
    grid-column: 1 / 3;
`;

const ContactDealerContainer = styled.div`
    grid-row: 2 / 3;
    grid-column: 1 / 2;

    display: flex;
    align-items: flex-end;

    @media screen and (max-width: 780px) {
        grid-row: 3 / 4;
        grid-column: 1 / 3;
    }
`;

const LocalDealerContainer = styled.div`
    grid-row: 2 / 3;
    grid-column: 2 / 3;

    @media screen and (max-width: 780px) {
        grid-column: 1 / 2;
    }
`;

interface NoResultsVehicleContainerInterface {
    isLocalDealer? : boolean
}

const NoResultsVehicle = (props : NoResultsVehicleContainerInterface) => {

    const { tracking } = useFeatureServices();
    const { isLoading, localDealer } = useDealersStore();
    const { labels, error_messages: { no_dealer_stock, no_stock } } = getTranslations();

    const { applied: { model } } = useAppliedFilterStore();

    const onDealerWebsiteHandler = (e: React.SyntheticEvent<HTMLButtonElement>) => {
      if(localDealer && localDealer.website) {
        window.open(localDealer.website, '_blank')?.focus();
        tracking.track('VWBasic_DealerButton_Click', {
          ...createConstantData(),
          partner: createPartner(localDealer),
          link: {
            url: localDealer?.website,
            name: e.currentTarget.innerText
          }
        });
      }
    }

    return isLoading
    ? <></>
    : (
        <Container stretchContent wrap={'always'}>
            <ResultsHeadline background='001E50' color='FFF'>
                <Text tag={TextTag.h2} appearance={TokenTextAppearance.bigcopy100} color={TokenTextColor.inherit}>
                    { replaceStringWithJSX(labels.local_results, { localDealer: <Text bold>{localDealer?.name}</Text> }) }
                </Text>
            </ResultsHeadline>

            <DealerizationContainer>
                <LocalDealerHeadline>
                    {
                      props.isLocalDealer
                      ?  <Container wrap="always" gutter={ContainerGutter.static250} padding={{ bottom: ContainerPadding.static250 }}>
                            <Text tag={TextTag.p} appearance={TokenTextAppearance.headline300}>
                              { replaceStringWithJSX(no_dealer_stock.subhead, { localDealer: <Text bold>{localDealer.name}</Text> }) }
                            </Text>
                            <Text tag={TextTag.p} appearance={TokenTextAppearance.headline200}>
                              { replaceStringWithJSX(no_dealer_stock.copy, { localDealer: <Text bold>{localDealer.name}</Text> }) }
                            </Text>
                        </Container>
                      : <Container wrap="always" gutter={ContainerGutter.static250} padding={{ bottom: ContainerPadding.static250 }}>
                            <Text tag={TextTag.h2} appearance={TokenTextAppearance.headline300} bold>
                              { no_stock.header }
                            </Text>
                            <Text tag={TextTag.p} appearance={TokenTextAppearance.headline300}>
                              { no_stock.subhead }
                            </Text>
                            <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
                              { replaceStringWithJSX(no_stock.copy, { localDealer: <Text bold>{localDealer.name}</Text> }) }
                            </Text>
                        </Container>
                    }
                </LocalDealerHeadline>

                <ContactDealerContainer>
                    <Container gutter={ContainerGutter.static250} verticalAlign="center">
                        <CTA tag="button" onClick={onDealerWebsiteHandler}>{ no_stock.contact_dealer }</CTA>

                        {!model?.includes('id4') && <FactoryOrder />}
                    </Container>
                </ContactDealerContainer>

                <LocalDealerContainer>
                    <LocalDealer dealer={localDealer} />
                </LocalDealerContainer>
            </DealerizationContainer>
        </Container>
    );
}

export default NoResultsVehicle;
